import { render, staticRenderFns } from "./RoundAvatar.vue?vue&type=template&id=0b8abd9c"
import script from "./RoundAvatar.vue?vue&type=script&lang=js"
export * from "./RoundAvatar.vue?vue&type=script&lang=js"
import style0 from "./RoundAvatar.vue?vue&type=style&index=0&id=0b8abd9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports